<template>
  <div class="common_content">
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="6" :md="4" style="padding:10px">
          <personal-menu :role="Number(userRole)" v-if="screenWidth<=767?navShow:!navShow" />
          <phone-menu :role="Number(userRole)" v-else />
        </el-col>
        <el-col :xs="24" :sm="18" :md="20">
          <router-view></router-view>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import personalMenu from "@/views/admin/components/personalMenu.vue";
import phoneMenu from "@/views/admin/components/phoneMenu.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    personalMenu,
    phoneMenu
  },
  computed: {
    ...mapGetters(["userRole", "screenWidth"])
  },
  data() {
    return {
      navShow: false
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.personal {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
  padding: 15px;
}
</style>